import React, { ReactNode } from 'react';

import { CardActions, CardTitle } from 'common/components/Card/card.styled';
import { Header } from 'common/components/Card/SummeryCard/SummeryCard.styled';

interface IProps {
  title: string;
  actions?: ReactNode;
  cardActionsIconColor?: string;
}

export const SummeryCardTitle = ({ title, actions, cardActionsIconColor }: IProps) => {
  return (
    <Header>
      <CardTitle>{title}</CardTitle>
      <CardActions cardActionsIconColor={cardActionsIconColor}>{actions}</CardActions>
    </Header>
  );
};
